<template>
  <!-- Table Container Card -->
  <b-card no-body>
    <div class="ml-2 mr-2">
      <validation-observer ref="gatewayConfigRules">
        <b-form
          id="gateway-fee-configuration"
          @submit.prevent="handleSubmit"
        >
          <b-row>
            <b-col cols="12">
              <h5 class="section-label mb-2 mt-2">
                {{ $t('Interbank Profile Setup') }}
              </h5>
              <div ref="gatewayConfigRef">
                <b-row class="match-height mb-3">
                  <b-col md="6">
                    <InputField
                      id="name"
                      v-model="bankDetailsFormData.name"
                      type="text"
                      :label="$t('Name')"
                      :placeholder="$t('Name')"
                      :error-name="$t('Name')"
                      :readonly="!isEditable"
                    />
                  </b-col>
                  <b-col md="6">
                    <InputField
                      id="nipInstitutionCode"
                      v-model="bankDetailsFormData.nipInstitutionCode"
                      type="text"
                      :label="$t('NIP Institution Code')"
                      :placeholder="$t('NIP Code')"
                      :error-name="$t('NIP Code')"
                      :readonly="!isEditable"
                    />
                  </b-col>
                  <b-col md="6">
                    <InputField
                      id="branchCode"
                      v-model="bankDetailsFormData.branchCode"
                      type="text"
                      :label="$t('Branch Code')"
                      :placeholder="$t('Branch Code')"
                      :error-name="$t('Branch Code')"
                      :readonly="!isEditable"
                    />
                  </b-col>

                  <!-- <b-col md="6">
                    <SelectField
                      id="gateway"
                      v-model="bankDetailsFormData.gateway"
                      :label="$t('Gateway')"
                      :placeholder="$t('Select Gateway')"
                      :options="gatewayOptions"
                      :loading="isGatewayLoading"
                      :reduce="option => option.value"
                      :error-name="$t('Gateway')"
                      item="label"
                      :disabled="!isEditable"
                    />
                  </b-col> -->
                  <!-- <b-col md="6">
                    <InputField
                      id="monthlyTrxCountBeforeOTFeeChargeToCustomer"
                      v-model="bankDetailsFormData.monthlyTrxCountBeforeOTFeeChargeToCustomer"
                      :label="$t('Monthly Trx Count Before Fee Charge To Customer')"
                      :placeholder="$t('Enter Monthly Trx Count')"
                      type="number"
                      :error-name="$t('Monthly Trx Count')"
                    />
                  </b-col> -->
                  <b-col md="6">
                    <InputField
                      id="inwardEntryCode"
                      v-model="bankDetailsFormData.inwardEntryCode"
                      type="text"
                      :label="$t('Inward Entry Code')"
                      :placeholder="$t('Enter Inward Entry Code')"
                      error-name="Inward Entry Code"
                      :readonly="!isEditable"
                    />
                  </b-col>
                  <b-col md="6">
                    <InputField
                      id="outwardTransferEntryCode"
                      v-model="bankDetailsFormData.outwardTransferEntryCode"
                      type="text"
                      :label="$t('Outward Transfer Entry Code')"
                      :placeholder="$t('Enter Transfer Entry Code')"
                      :error-name="$t('Outward Transfer Entry Code')"
                      :readonly="!isEditable"
                    />
                  </b-col>
                  <b-col md="6">
                    <InputField
                      id="outwardTransferFeeEntryCode"
                      v-model="bankDetailsFormData.outwardTransferFeeEntryCode"
                      type="text"
                      :label="$t('Outward Transfer Fee Entry Code')"
                      :placeholder="$t('Enter Outward Transfer Fee EntryCode')"
                      error-name="Outward Transfer Fee EntryCode"
                      :readonly="!isEditable"
                    />
                  </b-col>
                  <b-col md="6">
                    <InputField
                      id="expenseGL"
                      v-model="bankDetailsFormData.expenseGL"
                      type="text"
                      :label="$t('Expense GL')"
                      :placeholder="$t('Enter Expense GL')"
                      :error-name="$t('Expense GL')"
                      :readonly="!isEditable"
                    />

                  </b-col>
                  <b-col md="6">
                    <InputField
                      id="nipInwardMaxRetry"
                      v-model="bankDetailsFormData.nipInwardMaxRetry"
                      :label="$t('NIP Inward Max-Retry')"
                      :placeholder="$t('NIP Inward Max-Retry')"
                      type="number"
                      :max-length="1"
                      :is-allow-negative-numbers="false"
                      :error-name="$t('NIP Inward Max-Retry')"
                      :readonly="!isEditable"
                    />
                  </b-col>
                  <b-col md="6">
                    <SelectField
                      id="nipMode"
                      v-model="bankDetailsFormData.nipMode"
                      :label="$t('Select NIP Mode')"
                      :reduce="option=>option.value"
                      :placeholder="$t('Select')"
                      :options="nipModeOptions"
                      :loading="isNIPLoading"
                      :error-name="$t('NIP Mode')"
                      item="label"
                      :readonly="!isEditable"
                    />
                  </b-col>
                  <!-- These blocks of code may be needed later. Hence, not to be deleted -->
                  <!-- <b-col md="6">
                    <InputField
                      id="easyPayMandateBank"
                      v-model="bankDetailsFormData.easyPayMandateBank"
                      type="text"
                      :label="$t('EasyPay Mandate Bank')"
                      :placeholder="$t('Enter EasyPay Mandate Bank')"
                      :error-name="$t('EasyPay Mandate Bank')"
                    />
                  </b-col> -->
                  <!-- <b-col md="6">
                    <InputField
                      id="easyPayMandateBankNIPCode"
                      v-model="bankDetailsFormData.easyPayMandateBankNIPCode"
                      type="text"
                      :label="$t('EasyPay Mandate Bank NIP Code')"
                      :placeholder="$t('Enter EasyPay Mandate Bank NIP Code')"
                      :error-name="$t('EasyPay Mandate Bank NIP Code')"
                    />
                  </b-col> -->
                  <!-- <b-col md="6">
                    <InputField
                      id="easyPayMandateAccountNumber"
                      v-model="bankDetailsFormData.easyPayMandateAccountNumber"
                      type="text"
                      :label="$t('EasyPay Mandate Account Number')"
                      :placeholder="$t('Enter EasyPay Mandate Account Number')"
                      :error-name="$t('EasyPay Mandate Account Number')"
                    />
                  </b-col> -->
                  <!-- <b-col md="6">
                    <InputField
                      id="easyPayMandateAccountBVN"
                      v-model="bankDetailsFormData.easyPayMandateAccountBVN"
                      type="text"
                      :label="$t('EasyPay Mandate Account BVN')"
                      :placeholder="$t('Enter EasyPay Mandate Account BVN')"
                      :error-name="$t('EasyPay Mandate Account BVN')"
                    />
                  </b-col> -->

                  <!-- These blocks of code may be needed later -->
                  <!-- <b-col md="6">
                    <InputField
                      id="easyPayBillerId"
                      v-model="bankDetailsFormData.easyPayBillerId"
                      type="text"
                      :label="$t('EasyPay Biller Id')"
                      :placeholder="$t('Enter EasyPay Biller Id')"
                      :error-name="$t('EasyPay Biller Id')"
                      readonly
                    />

                  </b-col> -->
                  <b-col md="6">
                    <InputField
                      id="iswInstitutionCode"
                      v-model="bankDetailsFormData.iswInstitutionCode"
                      type="text"
                      :label="$t('ISW Institution Code')"
                      :placeholder="$t('Enter ISW Institution Code')"
                      :error-name="$t('ISW Institution Code')"
                      :readonly="!isEditable"
                    />
                  </b-col>
                  <b-col md="6">
                    <InputField
                      id="habariInstitutionCode"
                      v-model="bankDetailsFormData.habariInstitutionCode"
                      type="text"
                      :label="$t('Habari Institution Code')"
                      :placeholder="$t('Enter Habari Institution Code')"
                      :error-name="$t('Habari Institution Code')"
                      :readonly="!isEditable"
                    />
                  </b-col>
                  <b-col md="6">
                    <InputField
                      id="eTranzactInstitutionCode"
                      v-model="bankDetailsFormData.eTranzactInstitutionCode"
                      type="text"
                      :label="$t('eTranzact Institution Code')"
                      :placeholder="$t('Enter eTranzact Institution Code')"
                      :error-name="$t('eTranzact Institution Code')"
                      :readonly="!isEditable"
                    />
                  </b-col>
                  <b-col md="6">
                    <InputField
                      id="remitaInstitutionCode"
                      v-model="bankDetailsFormData.remitaInstitutionCode"
                      type="text"
                      :label="$t('Remita Institution Code')"
                      :placeholder="$t('Enter Remita Institution Code')"
                      :error-name="$t('Remita Institution Code')"
                      :readonly="!isEditable"
                    />
                  </b-col>
                  <b-col md="6">
                    <InputField
                      id="stampDutyEntryCode"
                      v-model="bankDetailsFormData.stampDutyEntryCode"
                      type="text"
                      :label="$t('Stamp Duty EntryCode')"
                      :placeholder="$t('Enter Stamp Duty EntryCode')"
                      :error-name="$t('Stamp Duty EntryCode')"
                      :readonly="!isEditable"
                    />
                  </b-col>
                  <b-col md="6">
                    <span class="mt-0 mb-0">{{ $t('Allow Outward Transfer Fee Override From API') }}</span>
                    <div>
                      <small>
                        <em>If this is checked, then the fee configured on Open API will be used for API transfers instead of the global fee configured per gateway.</em>
                      </small>
                    </div>
                    <b-form-radio-group
                      v-model="bankDetailsFormData.allowOutwardTransferFeeOverride"
                      :options="translatedOutwardResponseOptions"
                      class="demo-inline-spacing"
                      name="allow-outward-transfer-fee-override"
                      :disabled="!isEditable"
                    />
                  </b-col>
                  <b-col md="6">
                    <span class="mt-0 mb-0">{{ $t('Ignore Account Status Check For Inward Transfers') }}</span>
                    <div>
                      <small>
                        <em>If this is set to true, whenever an inward is sent to an inactive account, the credit will be applied.</em>
                      </small>
                    </div>
                    <b-form-radio-group
                      v-model="bankDetailsFormData.ignoreAccountStatusCheck"
                      :options="translatedIgnoreAccountStatusCheckOptions"
                      class="demo-inline-spacing"
                      name="ignore-account-status-check"
                      :disabled="!isEditable"
                    />
                  </b-col>
                </b-row>
              </div>
              <div class="text-center">
                <Button
                  v-if="getUserPermission('MANAGE_INTERBANK_PROFILE')"
                  :label="buttonLabel"
                  :loading="isLoading"
                  :disabled="isDisabled || isLoading"
                  size="lg"
                  @click="handleSubmit"
                />
              </div>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </div>
    <FullScreenSpinner :show="showSpinner" />
  </b-card>

</template>

<script>
import {
  BCard, BRow, BCol,
  BForm, VBTooltip, BFormRadioGroup,
} from 'bootstrap-vue'
import { ValidationObserver } from 'vee-validate'
import { mapActions } from 'vuex'
import { modalMixins } from '@core/mixins/modal'
import { tableMixins } from '@core/mixins/table'
import { sweetAlert } from '@core/mixins/sweetAlert'
import {
  required, amount, positive,
} from '@validations'
import { permissionMixin } from '@core/mixins/permission'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import InputField from '../../../../forms/InputField.vue'
import {
  toAmount, toBalance,
} from '@/helpers/formatAmount'
import { toDateWithYear } from '../../../../../helpers/formatDate'
import getStatusColor from '../../../../../helpers/getStatusColor'
import SelectField from '../../../../forms/SelectField.vue'
import Button from '../../../../components/button/Button.vue'
import { eChannelsPermission } from '../../../../../helpers/permissions'
// Gateway Options
const gatewayOptions = [
  { label: 'NIP', value: 'NIP' },
  { label: 'ETZ', value: 'ETZ' },
  { label: 'ISW', value: 'ISW' },
]
// NIP Mode Options
const nipModeOptions = [

  { label: 'EasyPay', value: 'EasyPay' },
  { label: 'NIP', value: 'NIP' },
]
export default {
  components: {
    BCard,
    BRow,
    BCol,
    BForm,
    BFormRadioGroup,
    ValidationObserver,
    InputField,
    FullScreenSpinner,
    SelectField,
    Button,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  mixins: [modalMixins, tableMixins, sweetAlert, permissionMixin],
  data() {
    return {
      toDateWithYear,
      showSpinner: false,
      buttonLabel: this.$t('Edit'),
      isDisabled: false,
      isCustomDisabled: false,
      isLoading: false,
      isEditable: false,
      required,
      toAmount,
      toBalance,
      amount,
      positive,
      getStatusColor,
      gatewayProviderOptions: [],
      bankDetailsFormData: {
        nipInstitutionCode: '',
        cbaInstitutionID: '',
        name: '',
        monthlyTrxCountBeforeOTFeeChargeToCustomer: 0,
        branchCode: '',
        gateway: '',
        inwardEntryCode: '',
        outwardTransferEntryCode: '',
        outwardTransferFeeEntryCode: '',
        expenseGL: '',
        nipInwardMaxRetry: 0,
        nipMode: '',
        easyPayMandateBank: '',
        easyPayMandateBankNIPCode: '',
        easyPayMandateAccountNumber: '',
        easyPayMandateAccountBVN: '',
        easyPayMandateAccountName: '',
        easyPayBillerId: '',
        iswInstitutionCode: '',
        habariInstitutionCode: '',
        eTranzactInstitutionCode: '',
        remitaInstitutionCode: '',
        stampDutyEntryCode: '',
        easyPayMandateRef: '',
        isGatewayLoading: false,
        gatewayOptions: [],
        isNIPLoading: false,
        // nipModeOptions are provided via computed; keep v-model as string
        ignoreAccountStatusCheck: false,
        allowOutwardTransferFeeOverride: true,
      },
      outwardResponseOptions: [
        { text: this.$t('Yes'), value: true },
        { text: this.$t('No'), value: false },
      ],

      ignoreAccountStatusCheckOptions: [
        { text: this.$t('Yes'), value: true },
        { text: this.$t('No'), value: false },
      ],
    }
  },
  computed: {
    gatewayOptions() {
      return gatewayOptions
    },
    nipModeOptions() {
      return nipModeOptions
    },

    translatedOutwardResponseOptions() {
      return this.outwardResponseOptions.map(header => ({ ...header, text: header.text ? this.$t(header.text) : header.value }))
    },
    translatedIgnoreAccountStatusCheckOptions() {
      return this.ignoreAccountStatusCheckOptions.map(header => ({ ...header, text: header.text ? this.$t(header.text) : header.value }))
    },
  },
  watch: {
    currentPage(newValue) {
      this.currentPage = newValue
      this.fetchBankProfile()
    },
    perPage(newValue) {
      this.perPage = newValue
      this.fetchBankProfile()
    },
    'bankDetailsFormData.nipInwardMaxRetry': {
      handler(val) {
        const num = Number(val)
        if (Number.isNaN(num)) {
          this.bankDetailsFormData.nipInwardMaxRetry = 0
          return
        }
        const clamped = Math.max(0, Math.min(3, Math.trunc(num)))
        if (clamped !== num) {
          this.bankDetailsFormData.nipInwardMaxRetry = clamped
        }
      },
    },
  },
  mounted() {
    this.fetchBankProfile()
  },
  methods: {
    ...mapActions({
      getGateways: 'eChannels/getGateways',
      getInterbankProfile: 'eChannels/getInterbankProfile',
      updateInterbankProfile: 'eChannels/updateInterbankProfile',
    }),
    onViewGLInfo() {
      this.$root.$emit('bv::show::modal', 'customer-atm-default-limit-modal')
    },
    checkNumberLimit(e) {
      return String(e).substring(0, 3)
    },

    handleSubmit() {
      if (!this.isEditable && this.buttonLabel === this.$t('Edit')) {
        this.isEditable = true
        this.buttonLabel = this.$t('Update')
        return
      }

      this.$refs.gatewayConfigRules.validate().then(async success => {
        if (success) {
          const areYouSure = this.$t('Are you sure you want to')
          const thisText = this.$t('this Profile?')
          this.confirm(this.profileConfigAction, { text: `${areYouSure} ${this.buttonLabel} ${thisText}` })
        }
      })
    },
    async profileConfigAction() {
      try {
        this.isLoading = true
        const formData = {
          nipInstitutionCode: this.bankDetailsFormData.nipInstitutionCode,
          cbaInstitutionID: this.bankDetailsFormData.cbaInstitutionID,
          name: this.bankDetailsFormData.name,
          monthlyTrxCountBeforeOTFeeChargeToCustomer: this.bankDetailsFormData.monthlyTrxCountBeforeOTFeeChargeToCustomer,
          branchCode: this.bankDetailsFormData.branchCode,
          gateway: this.bankDetailsFormData.gateway,
          inwardEntryCode: this.bankDetailsFormData.inwardEntryCode,
          outwardTransferEntryCode: this.bankDetailsFormData.outwardTransferEntryCode,
          outwardTransferFeeEntryCode: this.bankDetailsFormData.outwardTransferFeeEntryCode,
          expenseGL: this.bankDetailsFormData.expenseGL,
          nipInwardMaxRetry: this.bankDetailsFormData.nipInwardMaxRetry,
          nipMode: this.bankDetailsFormData.nipMode,
          easyPayMandateBank: this.bankDetailsFormData.easyPayMandateBank,
          easyPayMandateBankNIPCode: this.bankDetailsFormData.easyPayMandateBankNIPCode,
          easyPayMandateAccountNumber: this.bankDetailsFormData.easyPayMandateAccountNumber,
          easyPayMandateAccountBVN: this.bankDetailsFormData.easyPayMandateAccountBVN,
          easyPayMandateAccountName: this.bankDetailsFormData.easyPayMandateAccountName,
          easyPayBillerId: this.bankDetailsFormData.easyPayBillerId,
          iswInstitutionCode: this.bankDetailsFormData.iswInstitutionCode,
          habariInstitutionCode: this.bankDetailsFormData.habariInstitutionCode,
          eTranzactInstitutionCode: this.bankDetailsFormData.eTranzactInstitutionCode,
          remitaInstitutionCode: this.bankDetailsFormData.remitaInstitutionCode,
          stampDutyEntryCode: this.bankDetailsFormData.stampDutyEntryCode,
          ignoreAccountStatusCheck: this.bankDetailsFormData.ignoreAccountStatusCheck,
          allowOutwardTransferFeeOverride: this.bankDetailsFormData.allowOutwardTransferFeeOverride,
        }
        const response = await this.updateInterbankProfile({ formData, permission: eChannelsPermission.MANAGE_INTERBANK_PROFILE })
        const { status } = await response
        if (status === 200) {
          this.fetchBankProfile()
          const requestText = this.$t('Your request to')
          const feeText = this.$t('Bank Profile was successful')
          this.alertSuccess({ text: `${requestText} ${this.buttonLabel} ${feeText}` })
          this.isEditable = false
          this.buttonLabel = this.$t('Edit')
        }
      } catch (error) {
        error.response.data.errors.forEach(responseError => {
          this.hideModal('modal-lg')
          const requestText = this.$t('Your request to')
          const reasonText = this.$t('Bank Profile failed. Reason')
          const errorMessage = `${requestText} ${this.buttonLabel} ${reasonText}: ${responseError.errorMessage}`
          this.alertError({ text: errorMessage })
        })
      } finally {
        this.isLoading = false
      }
    },
    async fetchBankProfile() {
      try {
        this.isBusy = true
        this.showSpinner = true
        this.hideModal('modal-filter')
        const response = await this.getInterbankProfile({
          search: '',
          page: this.currentPage,
          limit: this.perPage,
          permission: eChannelsPermission.MANAGE_INTERBANK_PROFILE,
        })
        const { status, data } = response
        if (data.data === null) {
          this.buttonLabel = this.$t('Save')
          this.isEditable = true
          return
        }
        this.buttonLabel = this.$t('Edit')
        this.isEditable = false
        if (status === 200 && data) {
          this.bankDetailsFormData = {
            gateway: data.gateway,
            nipInstitutionCode: data.nipInstitutionCode,
            cbaInstitutionID: data.cbaInstitutionID,
            name: data.name,
            monthlyTrxCountBeforeOTFeeChargeToCustomer: data.monthlyTrxCountBeforeOTFeeChargeToCustomer,
            branchCode: data.branchCode,
            inwardEntryCode: data.inwardEntryCode,
            outwardTransferEntryCode: data.outwardTransferEntryCode,
            outwardTransferFeeEntryCode: data.outwardTransferFeeEntryCode,
            expenseGL: data.expenseGL,
            nipInwardMaxRetry: data.nipInwardMaxRetry,
            nipMode: data.nipMode,
            easyPayMandateBank: data.easyPayMandateBank,
            easyPayMandateBankNIPCode: data.easyPayMandateBankNIPCode,
            easyPayMandateAccountNumber: data.easyPayMandateAccountNumber,
            easyPayMandateAccountBVN: data.easyPayMandateAccountBVN,
            easyPayMandateAccountName: data.easyPayMandateAccountName,
            easyPayMandateRef: data.easyPayMandateRef,
            easyPayBillerId: data.easyPayBillerId,
            iswInstitutionCode: data.iswInstitutionCode,
            habariInstitutionCode: data.habariInstitutionCode,
            eTranzactInstitutionCode: data.eTranzactInstitutionCode,
            remitaInstitutionCode: data.remitaInstitutionCode,
            stampDutyEntryCode: data.stampDutyEntryCode,
            ignoreAccountStatusCheck: data.ignoreAccountStatusCheck,
            allowOutwardTransferFeeOverride: data.allowOutwardTransferFeeOverride,
          }
          // Clamp Max-Retry to 0-3 in case backend returns out-of-range values
          const v = Number(this.bankDetailsFormData.nipInwardMaxRetry)
          this.bankDetailsFormData.nipInwardMaxRetry = Number.isNaN(v) ? 0 : Math.max(0, Math.min(3, Math.trunc(v)))
          this.totalCount = data.recordCount
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.isBusy = false
        this.showSpinner = false
      }
    },
    async fetchGateway() {
      try {
        this.isGatewayLoading = true
        const { data, status } = await this.getGateways({
          search: '',
          page: 0,
          limit: 0,
          permission: eChannelsPermission.MANAGE_INTERBANK_PROFILE,
        })

        if (status === 200 && data.data) {
          this.gatewayOptions = data.data.map(item => ({ label: `${item.name}`, value: item.id }))
          this.isGatewayLoading = false
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.isGatewayLoading = false
      }
    },

  },
}
</script>
